// Generated from i18n-iso-countries (MIT). ISO 3166-1 alpha-2 → [numeric, short English name].
// world-atlas identifies countries by the numeric code.
export const COUNTRIES: Record<string, [string, string]> = {
	AD: ["020", "Andorra"],
	AE: ["784", "UAE"],
	AF: ["004", "Afghanistan"],
	AG: ["028", "Antigua and Barbuda"],
	AI: ["660", "Anguilla"],
	AL: ["008", "Albania"],
	AM: ["051", "Armenia"],
	AO: ["024", "Angola"],
	AQ: ["010", "Antarctica"],
	AR: ["032", "Argentina"],
	AS: ["016", "American Samoa"],
	AT: ["040", "Austria"],
	AU: ["036", "Australia"],
	AW: ["533", "Aruba"],
	AX: ["248", "Aland Islands"],
	AZ: ["031", "Azerbaijan"],
	BA: ["070", "Bosnia and Herzegovina"],
	BB: ["052", "Barbados"],
	BD: ["050", "Bangladesh"],
	BE: ["056", "Belgium"],
	BF: ["854", "Burkina Faso"],
	BG: ["100", "Bulgaria"],
	BH: ["048", "Bahrain"],
	BI: ["108", "Burundi"],
	BJ: ["204", "Benin"],
	BL: ["652", "Saint Barthélemy"],
	BM: ["060", "Bermuda"],
	BN: ["096", "Brunei Darussalam"],
	BO: ["068", "Bolivia"],
	BQ: ["535", "Bonaire, Sint Eustatius and Saba"],
	BR: ["076", "Brazil"],
	BS: ["044", "Bahamas"],
	BT: ["064", "Bhutan"],
	BV: ["074", "Bouvet Island"],
	BW: ["072", "Botswana"],
	BY: ["112", "Belarus"],
	BZ: ["084", "Belize"],
	CA: ["124", "Canada"],
	CC: ["166", "Cocos (Keeling) Islands"],
	CD: ["180", "DR Congo"],
	CF: ["140", "Central African Republic"],
	CG: ["178", "Congo"],
	CH: ["756", "Switzerland"],
	CI: ["384", "Côte d'Ivoire"],
	CK: ["184", "Cook Islands"],
	CL: ["152", "Chile"],
	CM: ["120", "Cameroon"],
	CN: ["156", "China"],
	CO: ["170", "Colombia"],
	CR: ["188", "Costa Rica"],
	CU: ["192", "Cuba"],
	CV: ["132", "Cape Verde"],
	CW: ["531", "Curaçao"],
	CX: ["162", "Christmas Island"],
	CY: ["196", "Cyprus"],
	CZ: ["203", "Czechia"],
	DE: ["276", "Germany"],
	DJ: ["262", "Djibouti"],
	DK: ["208", "Denmark"],
	DM: ["212", "Dominica"],
	DO: ["214", "Dominican Republic"],
	DZ: ["012", "Algeria"],
	EC: ["218", "Ecuador"],
	EE: ["233", "Estonia"],
	EG: ["818", "Egypt"],
	EH: ["732", "Western Sahara"],
	ER: ["232", "Eritrea"],
	ES: ["724", "Spain"],
	ET: ["231", "Ethiopia"],
	FI: ["246", "Finland"],
	FJ: ["242", "Fiji"],
	FK: ["238", "Falkland Islands (Malvinas)"],
	FM: ["583", "Micronesia, Federated States of"],
	FO: ["234", "Faroe Islands"],
	FR: ["250", "France"],
	GA: ["266", "Gabon"],
	GB: ["826", "UK"],
	GD: ["308", "Grenada"],
	GE: ["268", "Georgia"],
	GF: ["254", "French Guiana"],
	GG: ["831", "Guernsey"],
	GH: ["288", "Ghana"],
	GI: ["292", "Gibraltar"],
	GL: ["304", "Greenland"],
	GM: ["270", "The Gambia"],
	GN: ["324", "Guinea"],
	GP: ["312", "Guadeloupe"],
	GQ: ["226", "Equatorial Guinea"],
	GR: ["300", "Greece"],
	GS: ["239", "South Georgia and the South Sandwich Islands"],
	GT: ["320", "Guatemala"],
	GU: ["316", "Guam"],
	GW: ["624", "Guinea-Bissau"],
	GY: ["328", "Guyana"],
	HK: ["344", "Hong Kong"],
	HM: ["334", "Heard Island and McDonald Islands"],
	HN: ["340", "Honduras"],
	HR: ["191", "Croatia"],
	HT: ["332", "Haiti"],
	HU: ["348", "Hungary"],
	ID: ["360", "Indonesia"],
	IE: ["372", "Ireland"],
	IL: ["376", "Israel"],
	IM: ["833", "Isle of Man"],
	IN: ["356", "India"],
	IO: ["086", "British Indian Ocean Territory"],
	IQ: ["368", "Iraq"],
	IR: ["364", "Iran"],
	IS: ["352", "Iceland"],
	IT: ["380", "Italy"],
	JE: ["832", "Jersey"],
	JM: ["388", "Jamaica"],
	JO: ["400", "Jordan"],
	JP: ["392", "Japan"],
	KE: ["404", "Kenya"],
	KG: ["417", "Kyrgyzstan"],
	KH: ["116", "Cambodia"],
	KI: ["296", "Kiribati"],
	KM: ["174", "Comoros"],
	KN: ["659", "Saint Kitts and Nevis"],
	KP: ["408", "North Korea"],
	KR: ["410", "Korea, Republic of"],
	KW: ["414", "Kuwait"],
	KY: ["136", "Cayman Islands"],
	KZ: ["398", "Kazakhstan"],
	LA: ["418", "Lao People's Democratic Republic"],
	LB: ["422", "Lebanon"],
	LC: ["662", "Saint Lucia"],
	LI: ["438", "Liechtenstein"],
	LK: ["144", "Sri Lanka"],
	LR: ["430", "Liberia"],
	LS: ["426", "Lesotho"],
	LT: ["440", "Lithuania"],
	LU: ["442", "Luxembourg"],
	LV: ["428", "Latvia"],
	LY: ["434", "Libya"],
	MA: ["504", "Morocco"],
	MC: ["492", "Monaco"],
	MD: ["498", "Moldova, Republic of"],
	ME: ["499", "Montenegro"],
	MF: ["663", "Saint Martin (French part)"],
	MG: ["450", "Madagascar"],
	MH: ["584", "Marshall Islands"],
	MK: ["807", "North Macedonia"],
	ML: ["466", "Mali"],
	MM: ["104", "Myanmar"],
	MN: ["496", "Mongolia"],
	MO: ["446", "Macao"],
	MP: ["580", "Northern Mariana Islands"],
	MQ: ["474", "Martinique"],
	MR: ["478", "Mauritania"],
	MS: ["500", "Montserrat"],
	MT: ["470", "Malta"],
	MU: ["480", "Mauritius"],
	MV: ["462", "Maldives"],
	MW: ["454", "Malawi"],
	MX: ["484", "Mexico"],
	MY: ["458", "Malaysia"],
	MZ: ["508", "Mozambique"],
	NA: ["516", "Namibia"],
	NC: ["540", "New Caledonia"],
	NE: ["562", "Niger"],
	NF: ["574", "Norfolk Island"],
	NG: ["566", "Nigeria"],
	NI: ["558", "Nicaragua"],
	NL: ["528", "The Netherlands"],
	NO: ["578", "Norway"],
	NP: ["524", "Nepal"],
	NR: ["520", "Nauru"],
	NU: ["570", "Niue"],
	NZ: ["554", "New Zealand"],
	OM: ["512", "Oman"],
	PA: ["591", "Panama"],
	PE: ["604", "Peru"],
	PF: ["258", "French Polynesia"],
	PG: ["598", "Papua New Guinea"],
	PH: ["608", "Philippines"],
	PK: ["586", "Pakistan"],
	PL: ["616", "Poland"],
	PM: ["666", "Saint Pierre and Miquelon"],
	PN: ["612", "Pitcairn Islands"],
	PR: ["630", "Puerto Rico"],
	PS: ["275", "Palestine"],
	PT: ["620", "Portugal"],
	PW: ["585", "Palau"],
	PY: ["600", "Paraguay"],
	QA: ["634", "Qatar"],
	RE: ["638", "Reunion"],
	RO: ["642", "Romania"],
	RS: ["688", "Serbia"],
	RU: ["643", "Russia"],
	RW: ["646", "Rwanda"],
	SA: ["682", "Saudi Arabia"],
	SB: ["090", "Solomon Islands"],
	SC: ["690", "Seychelles"],
	SD: ["729", "Sudan"],
	SE: ["752", "Sweden"],
	SG: ["702", "Singapore"],
	SH: ["654", "Saint Helena"],
	SI: ["705", "Slovenia"],
	SJ: ["744", "Svalbard and Jan Mayen"],
	SK: ["703", "Slovakia"],
	SL: ["694", "Sierra Leone"],
	SM: ["674", "San Marino"],
	SN: ["686", "Senegal"],
	SO: ["706", "Somalia"],
	SR: ["740", "Suriname"],
	SS: ["728", "South Sudan"],
	ST: ["678", "Sao Tome and Principe"],
	SV: ["222", "El Salvador"],
	SX: ["534", "Sint Maarten (Dutch part)"],
	SY: ["760", "Syrian Arab Republic"],
	SZ: ["748", "Eswatini"],
	TC: ["796", "Turks and Caicos Islands"],
	TD: ["148", "Chad"],
	TF: ["260", "French Southern Territories"],
	TG: ["768", "Togo"],
	TH: ["764", "Thailand"],
	TJ: ["762", "Tajikistan"],
	TK: ["772", "Tokelau"],
	TL: ["626", "Timor-Leste"],
	TM: ["795", "Turkmenistan"],
	TN: ["788", "Tunisia"],
	TO: ["776", "Tonga"],
	TR: ["792", "Turkey"],
	TT: ["780", "Trinidad and Tobago"],
	TV: ["798", "Tuvalu"],
	TW: ["158", "Taiwan"],
	TZ: ["834", "Tanzania"],
	UA: ["804", "Ukraine"],
	UG: ["800", "Uganda"],
	UM: ["581", "United States Minor Outlying Islands"],
	US: ["840", "United States"],
	UY: ["858", "Uruguay"],
	UZ: ["860", "Uzbekistan"],
	VA: ["336", "Holy See (Vatican City State)"],
	VC: ["670", "Saint Vincent and the Grenadines"],
	VE: ["862", "Venezuela"],
	VG: ["092", "Virgin Islands, British"],
	VI: ["850", "Virgin Islands, U.S."],
	VN: ["704", "Vietnam"],
	VU: ["548", "Vanuatu"],
	WF: ["876", "Wallis and Futuna"],
	WS: ["882", "Samoa"],
	XK: ["983", "Kosovo"],
	YE: ["887", "Yemen"],
	YT: ["175", "Mayotte"],
	ZA: ["710", "South Africa"],
	ZM: ["894", "Zambia"],
	ZW: ["716", "Zimbabwe"],
}

const BY_NUMERIC = new Map(Object.entries(COUNTRIES).map(([a2, [num]]) => [num, a2]))

export function countryName(code: string | null | undefined): string {
	if (!code || code === '(none)' || code === 'XX') return 'Unknown'
	if (code === 'T1') return 'Tor network'
	return COUNTRIES[code]?.[1] ?? code
}

/** A real country with a shape on the map (not XX, T1 or "(none)"). */
export function isCountry(code: string): boolean {
	return Object.hasOwn(COUNTRIES, code)
}

export function alpha2FromNumeric(num: string | number): string | null {
	return BY_NUMERIC.get(String(num).padStart(3, '0')) ?? null
}

/** Regional-indicator emoji flag for an alpha-2 code. */
export function flag(code: string | null | undefined): string {
	if (!code || code.length !== 2 || code === 'XX' || code === 'T1') return '🏳️'
	return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)))
}
